export default __webpack_public_path__ + "zhinengyun8f4cb0.svg";